// extracted by mini-css-extract-plugin
export default {"container":"Accordion__container___Qrsva","header":"Accordion__header___H5_B5","content":"Accordion__content___uvmiL","removeCursor":"Accordion__removeCursor___IrzDj"};